// extracted by mini-css-extract-plugin
module.exports = {"scrollableTableContainer":"TripsTable_scrollableTableContainer__3zQ1x"};